import React from "react"
import { TableRow, Stack, FormHelperText, Typography } from "@mui/material"
import { COLORS, roundNumber } from "../../../utils"
import { PETextField } from "../StyledPackagingExecutionPreviewComponents"
import { StyledBodyCell } from "../../../components/styled/StyledTableComponents"
import PECellValue from "../PECellValue"

const PEReprodSectionField = ({
	section,
	sectionIndex,
	setFieldTouched,
	onChangeSectionRealWeight,
	errors,
	isLastItem = false
}) => {
	const handleChangeRealWeight = (e) => {
		if (!setFieldTouched) return
		setFieldTouched(`sections[${sectionIndex}].compressiblePackagingWeight`)
		onChangeSectionRealWeight(e.target.value, sectionIndex)
	}

	const handleOnWheel = (e) => {
		e.target.blur()
	}

	const handleOnKeyDown = (e) => {
		if (e.key === "Enter") {
			e.preventDefault()
			handleOnWheel(e)
		}
	}

	return (
		<TableRow>
			<StyledBodyCell leftEdge={true} lastTableRow={isLastItem}>
				{section.sectionName || "-"}
			</StyledBodyCell>
			<StyledBodyCell lastTableRow={isLastItem}>
				<PECellValue
					value1={roundNumber((section.counterWeighing?.weight || 0), 1)}
					value2={roundNumber((section.totalTheoreticalWeight || 0), 1)}
					unit="kg"
					style={{ color: COLORS.DRAFT_GREY }}
				/>
			</StyledBodyCell>
			<StyledBodyCell lastTableRow={isLastItem}>
				<Stack direction="row" alignItems="center" gap={1}>
					<PECellValue
						value1={Math.round(section.incompressiblePackagingWeight * 100) / 100}
						unit="kg"
						style={{ color: COLORS.DRAFT_GREY }}
					/>
				</Stack>
			</StyledBodyCell>
			<StyledBodyCell rightEdge={true} lastTableRow={isLastItem}>
				<Stack direction="row" alignItems="center" gap={1}>
					<PETextField
						name={`sections[${+sectionIndex}].compressiblePackagingWeight`}
						value={Math.round(section.compressiblePackagingWeight * 100) / 100}
						variant="outlined"
						onChange={handleChangeRealWeight}
						type="number"
						onWheel={handleOnWheel}
						onKeyDown={handleOnKeyDown}
						inputProps={{
							inputMode: "numeric",
							pattern: "[0-9]*"
						}}
					/>
					<Typography sx={{ color: COLORS.DRAFT_GREY, whiteSpace: "nowrap" }}> kg</Typography>
				</Stack>
				{errors?.sections?.[sectionIndex]?.compressiblePackagingWeight && (
					<FormHelperText error>
						{errors.sections[sectionIndex].compressiblePackagingWeight}
					</FormHelperText>
				)}
			</StyledBodyCell>
		</TableRow>
	)
}

export default PEReprodSectionField